module.exports = __webpack_public_path__ + "static/media/web3.1d01ae53.gif";